// ** React Imports
import { useContext, useEffect } from 'react'
import { NavLink } from 'react-router-dom'

// ** Third Party Components
import { Circle, Disc, X } from 'react-feather'

// ** Config
import { useReactOidc } from '@axa-fr/react-oidc-context'
import themeConfig from '@configs/themeConfig'
import { getLogoByAppId } from '@services/ApplicationService'
import noLogo from '@src/assets/images/avatars/anh_mac_dinh.jpg'
import logoSmall from '@src/assets/images/logo/logo-icon.png'
import { IntlContext } from '@src/utility/context/Internationalization'
import { useState } from 'react'
import { isNullOrEmpty } from '../../../utils'

const VerticalMenuHeader = props => {
  // ** Props
  const { menuCollapsed, setMenuCollapsed, setMenuVisibility, setGroupOpen, menuHover } = props

  const { oidcUser } = useReactOidc()
  const intlContext = useContext(IntlContext)
  const urlParams = new URLSearchParams(window.location.search)
  const appid = urlParams.get('app_id')
  const redirectUri = !isNullOrEmpty(sessionStorage.getItem("redirect_uri")) ? sessionStorage.getItem("redirect_uri") : "/"
  const headers = {
    Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
    "Accept-Language": intlContext.locale
  }
  const [logoAppUrl, setLogoAppUrl] = useState(!isNullOrEmpty(sessionStorage.getItem("logo_url")) ? sessionStorage.getItem("logo_url") : "no-logo")

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  useEffect(() => {
    if (!isNullOrEmpty(appid)) {
      getLogoByAppId(headers, appid)
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers[`content-type`] })
          // const logoUrl = URL.createObjectURL(blob)
          const reader = new FileReader()
          reader.onload = () => {
            const dataUrl = reader.result
            setLogoAppUrl(dataUrl)
            sessionStorage.setItem("logo_url", dataUrl)
          }
          reader.readAsDataURL(blob)
        })
        .catch((err) => {
          console.error('err: ', err)
        })
    }
  }, [appid])

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <Circle
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }

  const renderLogo = () => {
    if (logoAppUrl !== 'no-logo') {
      if (!isNullOrEmpty(logoAppUrl)) {
        return (
          <img src={logoAppUrl} loading="lazy" alt='logo-app' />
        )
      } else {
        return (
          <img src={noLogo} loading="lazy" alt="no-logo" />
        )
      }
    } else {
      return (
        <img src={themeConfig.app.appLogoImage} loading="lazy" alt="cyberid-logo" />
      )
    }
  }

  const redirectHost = () => {
    sessionStorage.removeItem("redirect_uri")
    sessionStorage.removeItem("app_name")
    sessionStorage.removeItem("logo_url")
    window.location.replace(redirectUri)
  }

  return (
    <div className='navbar-header'>
      <ul className='nav navbar-nav flex-row'>
        <li className='nav-item mr-auto'>
          {menuCollapsed === false ? (
            !isNullOrEmpty(redirectUri) ? (
              <a className='navbar-brand' onClick={() => redirectHost()}>
                <span id='logo-app' className='brand-logo'>
                  {renderLogo()}
                </span>
                <h2 className='brand-text mb-0'>{themeConfig.app.appName}</h2>
              </a>
            ) : (
              <NavLink to='/' rel="noopener noreferrer" className='navbar-brand'>
                <span id='logo-app' className='brand-logo'>
                  {renderLogo()}
                </span>
                <h2 className='brand-text mb-0'>{themeConfig.app.appName}</h2>
              </NavLink>
            )
          ) : (
            <NavLink to='/' className='navbar-brand'>
              <span className='brand-logo'>
                <img src={logoSmall} alt='logo' style={{ width: '100%' }} />
              </span>
              <h2 className='brand-text mb-0'>{themeConfig.app.appName}</h2>
            </NavLink>
          )}
        </li>
        <li className='nav-item nav-toggle'>
          <div className='nav-link modern-nav-toggle cursor-pointer'>
            <Toggler />
            <X onClick={() => setMenuVisibility(false)} className='toggle-icon icon-x d-block d-xl-none' size={20} />
          </div>
        </li>
      </ul>
    </div>
  )
}

export default VerticalMenuHeader
